@let isArchived = isArchived$ | async;
<mat-sidenav-container>
    <mat-sidenav #sidenav class="mat-elevation-z8" mode="side" opened>
        @if (sidenav.opened) {
            <div class="top-right-nav-toggle">
                <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }
        <div>

            <mat-action-list>
                <a (click)="scrollToComponent('details')" data-test="partnership-investments-nav-item">
                    <mat-list-item>General Partner Details</mat-list-item>
                </a>
                <a (click)="scrollToComponent('comments')" data-test="fund-details-nav-item">
                    <mat-list-item>Comments</mat-list-item>
                </a>
                <a (click)="scrollToComponent('funds')" data-test="fund-report-details-nav-item">
                    <mat-list-item>Funds</mat-list-item>
                </a>
                <a (click)="scrollToComponent('news')" data-test="news-nav-item">
                    <mat-list-item>News</mat-list-item>
                </a>
                <a (click)="scrollToComponent('documents')" data-test="documents-nav-item">
                    <mat-list-item>Documents</mat-list-item>
                </a>
            </mat-action-list>
        </div>
    </mat-sidenav>
        <mat-sidenav-content>
            @if (!sidenav.opened) {
                <div class="top-left-nav-toggle">
                    <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                        <mat-icon>menu</mat-icon>
                    </button>
                </div>
            }
            <div class="breadcrumb-container">
                <label class="breadcrumb" data-test="breadcrumb">
                    <ng-container>
                        <mat-icon>recent_actors</mat-icon>
                        <a routerLink="../../gp"> General Partner List</a>
                        <mat-icon>chevron_right</mat-icon>
                    </ng-container>
                    <ng-container>
                        <mat-icon>account_circle</mat-icon>
                        {{ (selectedGeneralPartner$ | async)?.name | traceableFormat }}
                    </ng-container>
                </label>
                <div class="detail-page-top-right-menu">
                    <button mat-icon-button class="menu-button"
                            [matMenuTriggerFor]="gpMenu"
                            aria-label="More options"
                            (click)="onGPMenuButtonClick($event)">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #gpMenu="matMenu">
                        <button mat-menu-item (click)="openDocumentGeneratorDialog()">
                            <mat-icon>article_shortcut</mat-icon>
                            <span>Generate Document</span>
                        </button>
                        <button mat-menu-item (click)="openArchiveConfirmation(!isArchived?.value)">
                            <mat-icon>{{ isArchived?.value ? 'unarchive' : 'archive' }}</mat-icon>
                            <span>{{ isArchived?.value ? 'Unarchive' : 'Archive' }}</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div class="page-content">
                <div>
                    <div class="detail-page-header">
                        @let generalPartner = selectedGeneralPartner$ | async;
                        <div>
                            <h1 title="Last modified: {{isArchived?.modDate | timestamp}}">{{ generalPartner?.name | traceableFormat }}</h1>
                        </div>
                        <div>
                            @if (isArchived?.value) {
                                <mat-chip
                                    class="archived gap-left"
                                    [disableRipple]="true"
                                    matTooltip="{{isArchived?.modDate | date}}">
                                    <mat-icon matChipAvatar>inventory_2</mat-icon>
                                    <span>Archived</span>
                                </mat-chip>
                            }
                        </div>
<!--                            @if (isArchived?.value) {-->
<!--                                <div>-->
<!--                            <mat-chip-->
<!--                                class="archived"-->
<!--                                [disableRipple]="true"-->
<!--                                matTooltip="{{isArchived?.modDate | date}}">-->
<!--                                <mat-icon matChipAvatar>inventory_2</mat-icon>-->
<!--                                <span>Archived</span>-->
<!--                            </mat-chip>-->
<!--                                </div>-->
<!--                        }-->
                        <valumize-favorite-star
                            [favType]="'GP'"
                            [label]="generalPartner?.name?.text ?? ''">
                        </valumize-favorite-star>
                    </div>
                </div>
                <valumize-general-partner-details></valumize-general-partner-details>
                @if ((selectedGeneralPartner$ | async); as gp) {
                    <valumize-news id="news" [label]="gp.name.text" [context]="'gp/' + gp.id"></valumize-news>
                }
                <valumize-document id="documents" [context]="'/portfolio/generalpartners/' + generalPartnerId + '/'"></valumize-document>
                <br/>
                <br/>
                <br/>
            </div>
        </mat-sidenav-content>

</mat-sidenav-container>
